import { GruvLogoMark } from "@/components/gruv/GruvLogoMark";

/**
 * Square GRUV brand mark for FAQ, contact, and legal page headers.
 */
export function FaqBrandMark() {
  return (
    <div className="gruv-faq__brand-mark">
      <GruvLogoMark width={48} height={48} />
    </div>
  );
}
